import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { checkedListEmptyMsg, dataNotFoundMsg, noInternetMsg, saveFailedMsg, savemsg, saveWarningMsg, serverMsg, showingCarryForwardDetailsForMsg, updateData, updateFailed, updateMsg } from "../../config/messageconstant";
import { mandatoryCheck } from "../../config/ValidationCheck";
import { CarryForwardLeaveProcessJson } from "../../DynamicFormsJson/Transaction/carryForwardLeaveProcess";
import {
    getLeaveTypeBySalesTeamAndLeaveYear,
} from "../../Slice/year.slice";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import CarryForwardAssignationProcessTable from "./CarryForwardAssignationProcessTable";
import { redColor } from "../../config/ColorObj";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import { getLeaveYear } from "../../Slice/year.slice";

class CarryForwardAssignationProcess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                leaveYearMasterDetail: [],
            },
            formErrors: {},
            fieldData: {},
            salesTeamDataList: [],
            formErrorForDetails: {},
            carryForwardLeaveData: {},
            onSearchAPIStatusCode: 0,
        }
    }

    async componentDidMount() {
        const { getLeaveYear, showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            this.setState({ salesTeamDataList: [] });

            let salesTeamIdForCarryForward = this.props.params.id;

            showLoador({ loador: true });
            await getLeaveYear().then(({ response, success }) => {
                if (!success) {
                    showNotification({
                        msg: serverMsg,
                        severity: "error",
                    });
                } else {
                    this.setState({
                        dynamicMasterData: {
                            ...this.state.dynamicMasterData,
                            leaveYearMasterDetail: response || [],
                        },
                    });
                }
            });
            showLoador({ loador: false });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }




    getListById = async (data) => {
        const {
            getLeaveTypeBySalesTeamAndLeaveYear,
            showLoador,
            showNotification,
        } = this.props;
        if (navigator.onLine) {

            let salesTeamIdForCarryForward = this.props.params.id;
            if (data.leaveYearId && data.leaveYearId != "") {
                showLoador({ loador: true });
                await getLeaveTypeBySalesTeamAndLeaveYear({
                    salesTeamId: salesTeamIdForCarryForward,
                    leaveYearId: data.leaveYearId
                }).then(({ response, success }) => {
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    } else {

                        if (Object.keys(response).length !== 0) {

                            if (response?.leaveTypes.length == 0) {
                                return showNotification({ msg: dataNotFoundMsg, severity: "error" });
                            }

                            this.setState({ onSearchAPIStatusCode: response?.statusCode, salesTeamDataList: response.leaveTypes ?? [], carryForwardLeaveData: response ?? {} });
                        }
                    }
                }
                );
                showLoador({ loador: false });
            }
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };


    checkValidationOnSubmitForDetails = () => {
        const { salesTeamDataList } = this.state;
        let formErrorForDetails = {};
        let formIsValid = true;
        let errorMessage = "This field is required";

        salesTeamDataList.map((item) => {
            if (item.carryForwardDays === "" || item.carryForwardDays === null || item.carryForwardDays === undefined) {
                formIsValid = false;
                formErrorForDetails[`carryForwardDaysError${item.id}`] = errorMessage;
            }
        });

        this.setState({ formErrorForDetails });
        return formIsValid;
    };


    checkValidationOnSubmit = () => {
        const { fieldData } = this.state;
        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: CarryForwardLeaveProcessJson.fieldMeta,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });

        return mandatoryCheckErrors.formValid;
    };

    submithandler = () => {
        const { fieldData, salesTeamDataList, carryForwardLeaveData } = this.state;

        let salesTeamIdForCarryForward = this.props.params.id;

        let carryForwardLeaveDetails = salesTeamDataList.map((dataObj) => {
            return {
                leaveType: { id: dataObj.id },
                carryForwardDays: dataObj.carryForwardDays,
            }
        });

        let dataToSave = {
            salesTeam: { id: salesTeamIdForCarryForward },
            leaveYear: { id: fieldData.leaveYearId },
            previousleaveYear: { id: carryForwardLeaveData?.leaveYearId },
            carryForwardLeaveDetails: carryForwardLeaveDetails
        }

        if (this.checkValidationOnSubmit() && this.checkValidationOnSubmitForDetails()) {
            this.onSave(dataToSave);
        }
    }

    onSave = (dataToSave) => {
        const { showLoador, showNotification } = this.props;
        const { onSearchAPIStatusCode } = this.state;
        if (navigator.onLine) {

            let url = onSearchAPIStatusCode == 200 ?
                endpoint.carryForwardLeaveHeader + "/update?salesTeamId=" + dataToSave?.salesTeam?.id
                + "&leaveYearId=" + dataToSave?.leaveYear?.id : endpoint.carryForwardLeaveHeader;

            swal({
                title: "Are you sure?",
                text: updateData,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    await apiPost({
                        url: url,
                        postBody: dataToSave,
                    }).then(({ data, success }) => {
                        if (success) {
                            showNotification({ msg: updateMsg });
                            this.props.navigate(-1);
                        } else {
                            showNotification({ msg: updateFailed, severity: "error" });
                        }
                    });
                    showLoador({ loador: false });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    onDataChange = (fieldName, newValue) => {
        const { fieldData } = this.state;
        const dataToSearch = {};
        const dataToReset = { ...this.state.fieldData };
        let listError = false;

        if (fieldName === "leaveYearId") {
            this.setState({ salesTeamDataList: [], carryForwardLeaveData: {} });
        }

        CarryForwardLeaveProcessJson.fieldMeta.map((currentField) => {
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");

                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });

                this.getListById(dataToSearch);
            }
            if (currentField.getDate && currentField.dataKey === fieldName) {
                dataToReset[currentField.getDate] = newValue.add(365, "day");
            }
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");
                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });
            }
            if (currentField.getListFrom) {
                const masterKeyList = currentField.getListFrom.split(",");
                masterKeyList.map((key) => {
                    if (key == fieldName && dataToReset[key]) {
                        delete dataToReset[currentField.dataKey];
                    }
                });
            }
            if (
                !listError &&
                fieldData[currentField.dataKey] &&
                currentField.controlType != "datepicker" &&
                currentField.getListFrom == undefined
            ) {
                dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
            }
            return null;
        });

        dataToReset[fieldName] = newValue;
        this.setState({
            fieldData: dataToReset,
        });
    };


    onChangeTextField = (e, id) => {
        const { salesTeamDataList } = this.state;
        const { name, value } = e.target;

        const updatedList = salesTeamDataList.map((item) => {
            if (item.id == id) {
                let validatedValue = value;

                const numericValue = parseFloat(value) || 0;

                if (numericValue < 0) {
                    validatedValue = 0;
                }

                return {
                    ...item,
                    [name]: validatedValue,
                };
            }
            return item;
        });

        this.setState({ salesTeamDataList: updatedList });
    };

    render() {
        const {
            fieldData,
            formErrors,
            dynamicMasterData,
            carryForwardLeaveData,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >

                    <DynamicFormWithoutValidation
                        dynamicMasterData={dynamicMasterData}
                        getListById={this.getListById}
                        showTitle={CarryForwardLeaveProcessJson.showTitle}
                        screenTitle={"Carry Forward Leave Assignation"}
                        fieldMeta={CarryForwardLeaveProcessJson.fieldMeta}
                        apiBaseURL={CarryForwardLeaveProcessJson.apiBaseURL}
                        formErrors={formErrors}
                        showSaveBtn={CarryForwardLeaveProcessJson.showSaveBtn}
                        showSaveBtnMain={false}
                        fieldData={fieldData}
                        onDataChange={this.onDataChange}
                        showBackToList={true}
                    />
                    {Object.keys(carryForwardLeaveData).length !== 0 &&
                        carryForwardLeaveData?.leaveYearName !== null &&
                        (<TypographyCompo
                            sx={{
                                fontSize: "15px",
                                fontWeight: 400,
                                color: redColor,
                                marginBottom: "15px",
                                marginLeft: "10px",
                            }}
                        >
                            Note : {showingCarryForwardDetailsForMsg + carryForwardLeaveData?.leaveYearName}
                        </TypographyCompo>)
                    }


                    <CarryForwardAssignationProcessTable
                        clickSubmitHandler={this.submithandler}
                        salesTeamDataList={this.state.salesTeamDataList}
                        onChangeTextField={this.onChangeTextField}
                        formErrorForDetails={this.state.formErrorForDetails}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    leaveYearList: state.year,
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
    getLeaveYear,
    getLeaveTypeBySalesTeamAndLeaveYear,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(CarryForwardAssignationProcess);
